<template>
  <el-container class="screen-parameters screen-parameters-fullHeight services" v-loading="loading || loadingDelete">
    <div class="clients-panel cash-list">
      <div class="clients-panel-container">
        <el-row class="black-inputs">
          <div class="cash-header">
            <div class="nav-toggle" @click="showHideScreenDiscount">
              <div id="nav-icon3" class="open"><span></span><span></span><span></span><span></span></div>
            </div>
            <div class="screen-title">Réductions</div>
          </div>
          <el-row>
            <el-col :md="{ span: 4, offset: 10 }" :xs="24" :sm="{ span: 12, offset: 12 }">
              <el-button type="primary" @click="editDiscountInfos(null, null, null)">Créer une réduction</el-button>
            </el-col>
          </el-row>
        </el-row>
        <el-row class="black-inputs">
          <el-col :md="24" class="screen-clients">
            <el-table ref="multipleTable" :data="getDiscountList">
              <el-table-column prop="name" label="Nom" sortable>
              </el-table-column>
              <el-table-column prop="startDate" label="Début" sortable>
                <template slot-scope="scope">
                  <span>{{ dateRenderer(scope.row.startDate) }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="endDate" label="Fin" sortable>
                <template slot-scope="scope">
                  <span>{{ dateRenderer(scope.row.endDate) }}</span>
                </template>
              </el-table-column>

              <el-table-column prop="days" label="Jours" sortable>
                <template slot-scope="scope">
                  <span>{{ scope.row.days.join(', ') }}</span>
                </template>
              </el-table-column>
              <el-table-column label=" " width="70">
                <template slot-scope="scope">
                </template>
              </el-table-column>
              <el-table-column label=" ">
                <template slot-scope="scope">
                  <el-button class="dark" type="primary" @click="editDiscountInfos(scope.row)">
                    <span class="mobile-show"><i class="el-icon-edit"></i></span>
                    <span class="mobile-hide">Modifier</span>
                  </el-button>
                </template>
              </el-table-column>
              <el-table-column label=" ">
                <template slot-scope="scope">
                  <el-popover placement="right" width="200" trigger="manual" v-model="scope.row.popupValidDelete"
                    popper-class="popup-delete black-inputs">
                    <p>Si vous voulez supprimer cette réduction, merci d'indiquer votre mot de passe</p>
                    <el-input v-model="checkPassValue" type="password"></el-input>
                    <div style="text-align: right; margin: 0">
                      <el-button size="mini" class="dark" type="primary"
                        @click="scope.row.popupValidDelete = false">Annuler</el-button>
                      <el-button type="primary" size="mini" @click="deleteDiscount(scope.row)">Confirmer</el-button>
                    </div>
                    <el-button slot="reference" @click="scope.row.popupValidDelete = !scope.row.popupValidDelete"
                      class="red">
                      Supprimer
                    </el-button>
                  </el-popover>
                </template>
              </el-table-column>
            </el-table>
            <div style="text-align: center;margin-top: 30px;">
              <el-pagination background layout="prev, pager, next" :total="total" @current-change="current_change">
              </el-pagination>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
  </el-container>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';

export default {
  name: 'DiscountList',
  components: {},
  data() {
    return {
      pagesize: 10,
      currentPage: 1,
      total: 0,
      loading: false,
      loadingDelete: false,
      checkPassValue: ''
    }
  },
  computed: {
    ...mapGetters({
      getAllDiscount: 'discount/getAllDiscount',
      getUidPublic: 'newUsers/getUidPublic'
    }),
    getDiscountList: function () {
      // clone days
      this.loading = true
      if (this.getAllDiscount.length > 0) {
        // ordering main ts datas
        const orderDiscountTab = this.getAllDiscount.sort((a, b) => {
          if (a.dates && b.dates && a.dates.length > 0 & b.dates.length > 0) {
            return (new Date(a.dates[0]).getTime() > new Date(b.dates[0]).getTime()) ? 1 : -1
          } return 1
        })
        // format data for tab display
        const formatedTab = []
        orderDiscountTab.map((discount) => {
          let typeCash = 'Normal'
          if (discount && discount.services && discount.services[discount.days[0]] && discount.services[discount.days[0]].cashOn) {
            typeCash = discount.services[discount.days[0]].cashType
          }
          let start = ''
          let end = ''
          if (discount.dates && discount.dates.length > 0) {
            start = new Date(discount.dates[0])
            end = new Date(discount.dates[1])
          }

          const days = []
          if (discount.Lundi.length > 0) days.push('Lundi')
          if (discount.Mardi.length > 0) days.push('Mardi')
          if (discount.Mercredi.length > 0) days.push('Mercredi')
          if (discount.Jeudi.length > 0) days.push('Jeudi')
          if (discount.Vendredi.length > 0) days.push('Vendredi')
          if (discount.Samedi.length > 0) days.push('Samedi')
          if (discount.Dimanche.length > 0) days.push('Dimanche')

          formatedTab.push({
            name: discount.name,
            days: days,
            startDate: start,
            endDate: end,
            type: typeCash,
            id: discount.id,
            popupValidDelete: false
          })
        })

        this.total = formatedTab.length
        this.loading = false
        return formatedTab.slice((this.currentPage - 1) * this.pagesize, this.currentPage * this.pagesize)
      }
      this.loading = false
      return []
    }
  },
  created: function () { },
  methods: {
    ...mapActions({
      deleteDiscountById: 'discount/deleteDiscountById',
      showHideScreenDiscount: 'displayer/showHideScreenDiscount',
      checkPassword: 'newUsers/checkPassword'
    }),
    ...mapMutations({
      setDialogError: 'displayer/setDialogError',
      setDialogEditDiscount: 'displayer/setDialogEditDiscount',
      setSelectedDiscountById: 'discount/setSelectedDiscountById',
      clearSelectedDiscount: 'discount/clearSelectedDiscount'
    }),

    current_change: function (currentPage) {
      this.currentPage = currentPage
    },
    strUcFirst: function (a) {
      return ((`${a}`).charAt(0).toUpperCase() + a.substr(1))[0]
    },
    dateRenderer: function (date) {
      if (date) {
        return `${this.leadingZero(date.getDate())}/${this.leadingZero(date.getMonth() + 1)}/${date.getFullYear()}`
      } else {
        return '-'
      }
    },
    leadingZero(value) {
      return (`0${value}`).slice(-2)
    },

    editDiscountInfos: function (discount) {
      if (discount && discount.id) this.setSelectedDiscountById(discount.id)
      else this.clearSelectedDiscount()
      this.setDialogEditDiscount(true)
    },
    deleteDiscount: function (el) {
      this.checkPassword(this.checkPassValue).then(() => {
        this.loadingDelete = true
        this.deleteDiscountById(el.id).then(() => {
          this.loadingDelete = false
          el.popupValidDelete = false
          this.checkPassValue = ''
        })
      })
    }
  }
}
</script>

<style lang="scss">
@use "../../styles/mixins";

.cash-list {
  button {
    height: 48px;
  }

  .el-col {
    @include mixins.mobile-landscape {
      margin-bottom: 10px;
    }

    @include mixins.mobile-portrait {
      margin-bottom: 10px;
    }
  }

  .el-range {
    &-editor {
      @include mixins.mobile-portrait {
        height: 100% !important;
        width: 100% !important;
        display: block;
        text-align: center;
      }
    }

    &__icon {
      @include mixins.mobile-portrait {
        display: block;
        width: 100%;
      }
    }

    &-input {
      @include mixins.mobile-portrait {
        display: block;
        height: 35px;
        width: 100%;
      }
    }

    &-separator {
      @include mixins.mobile-portrait {
        display: block;
        width: 90%;
      }
    }

    &__close-icon {
      @include mixins.mobile-portrait {
        top: 0;
        right: 10px;
        height: 35px;
        position: absolute;
      }
    }
  }
}

.inputEuro {
  text-align: center;

  &:after {
    content: '€';
    position: absolute;
    font-weight: 100;
    right: 20px;
    font-size: 16px;
  }
}

.inputCouv {
  text-align: center;

  &:after {
    content: 'couv.';
    position: absolute;
    font-weight: 100;
    right: 20px;
    font-size: 14px;
  }
}

.el-input__inner {
  text-align: center;
  width: 100%;
}

.mobile-show {
  display: none;

  @include mixins.mobile-landscape {
    display: block;
  }
}

.mobile-hide {
  display: block;
  padding: 0 10px;

  @include mixins.mobile-landscape {
    display: none;
  }
}
</style>
